import Ajax from 'Pub/js/ajax';
import { langCheck, GetQuery } from "Pub/js/utils.js";
import { getRelateidObj } from "Pages/NewHome/utilService";
import platform from "Pub/js/platform";
const { checkUrl } = platform.regExpUtil;

export const addExternalLink = (props, data) => {
    const newData = getAjaxNewData(props, data);
    // 新增
    return new Promise((resolve) => {
        Ajax({
            url: `/nccloud/platform/appregister/addexternallink.do`,
            info: {
                name: langCheck('0000PUB-000387') /* 国际化处理： 常用链接*/,
                action: langCheck("0000PUB-000435") /* 国际化处理： 新增*/
            },
            data: newData,
            // loading: true,
            success: ({ data: { data, success, error } }) => {
                if (success && data) {
                    resolve(data)
                }
            }
        });
    })
}


export const editExternalLink = (props, data) => {
    const newData = getAjaxNewData(props, data);
    return new Promise((resolve) => {
        Ajax({
            url: `/nccloud/platform/appregister/editexternallink.do`,
            info: {
                name: langCheck('0000PUB-000387') /* 国际化处理： 常用链接*/,
                action: langCheck("0000PUB-000436") /* 国际化处理： 修改*/
            },
            data: newData,
            // loading: true,
            success: ({ data: { data, success, error } }) => {
                if (success && data) {
                    // Notice({
                    //     status: "success",
                    //     msg: langCheck('0000PUB-000442') // 多语 -'修改成功'
                    // });
                    resolve(data);
                }
            }
        });
    })
}

/**
 * 
 * @param {*} props 
 * @param {*} data 
 * @returns 
 *  获取职责 pk_responsibility 并返回接口所需data
 */
export const getAjaxNewData = (props, data) => {
    const urlRequestObj = GetQuery(props.location.search);
    const relateidObj = getRelateidObj(
        urlRequestObj.pk_responsibility,
        urlRequestObj.is_group,
        urlRequestObj.workbenchid
    );

    if (relateidObj.type === 'responsibility') {
        data = { ...data, relateid: relateidObj.data }
    }
    return { ...data, isuser: relateidObj.code };
}


export const urlTest = (iptUrl) => {
    let newIptUrl = iptUrl === 'null' ? '' : iptUrl;
    if (!iptUrl.startsWith('http://')) {
        newIptUrl = `http://${newIptUrl}`
    }
    return iptUrl.length && iptUrl.length < 400 && checkUrl(newIptUrl)
};
// 获取图标key 兼容之前设置的图标
export const getImageKey = (externalLinkData) => {
    let image;
    if (JSON.stringify(externalLinkData) != '{}') {
        if (externalLinkData.image && externalLinkData.image.match(/images\/(\S*)\.svg/)) {
            // 为了兼容之前存的外联
            image = externalLinkData.image.match(/images\/(\S*)\.svg/)[1];
            image = image === "defaultIcon" ? 'externallinkicon1' : image;
        } else {
            if (externalLinkData.image === "defaultIcon") {
                image = 'externallinkicon1'
            } else {
                image = externalLinkData.image
            }
        }
    }
    return image || 'externallinkicon1';
}

// // 转换存redux里面的数据
// export const switchExternalLinksData = (data) => {
//     const { title: name, urllink: url, image, pk_group_app, pk_externallink } = data;
//     const obj = {
//         name,
//         // url: url === 'null' ? '' : url || '',
//         url,
//         image,
//         pk_group_app,
//         pk_externallink
//     }
//     return obj;
// }

// 外部链接多语输入框入参转结构

export const switchTitleData = (data) => {
    let titleResult = {};
    if (data) {
        for (let k in data) {
            titleResult[k] = data[k].value;
        }
    }
    return titleResult;
}